/**
 * List of missing countries
 * https://www.npmjs.com/package/react-select-country-list
 */
export const missingCountryList = [
  { value: 'KM', label: 'Anjouan' },
  { value: 'PS', label: 'Palestinian Territory' },
  { value: 'XK', label: 'Kosovo' },
  { value: 'COD', label: 'Zaire' },
]
